import { baseURL } from "./baseUrl";
import { cachedRequest, requestKey } from "./requestCache";

// Typography tokens change rarely; share one request for every caller.
const TYPOGRAPHY_TTL_MS = 10 * 60 * 1000;

export const apiGetWebsiteTextSettings = () =>
  cachedRequest(requestKey("website-text-settings"), TYPOGRAPHY_TTL_MS, async () => {
    const response = await baseURL.get("/website-text-settings");
    return response.data;
  });
